import { cn } from '@heroui/react'
import { useStatsigClient } from '@statsig/react-bindings'
import { useQuery } from '@tanstack/react-query'
import { TopBar } from 'components/Layout/TopBar'
import { TopBarContent } from 'components/Layout/TopBarProvider'
import { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { $fetch } from 'utils/fetch'
import AnalysisPresetConfigurator from '../Analysis/AnalysisPresetConfigurator'
import CitationSchemas from '../Analysis/CitationSchemas'
import PathwayHeatmap from '../ConvoPathways/HeatMap'
import RetoolDashboard from '../ConvoPathways/Hertz'
import ReportPage from '../Report/MainReportPage'
import CallAnalytics from './CallAnalytics'

export default function Analytics() {
  const [searchParams, setSearchParams] = useSearchParams()
  const { client: statsigClient } = useStatsigClient()

  const hidePathways = statsigClient.checkGate('hide_pathway_data')

  const tab = useMemo(() => {
    return searchParams.get('tab')
  }, [searchParams])

  const BASE_TABS = [
    {
      value: 'calls',
      label: 'Calls',
    },
    ...(hidePathways
      ? []
      : [{
          value: 'pathways',
          label: 'Pathways',
        }]),
    {
      value: 'presets',
      label: 'Presets',
    },
    {
      value: 'citations',
      label: 'Citations',
    },
    {
      value: 'reports',
      label: 'Reports',
    },
  ]

  const { data: { data: customTabs = [] } = {} } = useQuery({
    queryKey: ['availableTabs'],
    queryFn: () => {
      return $fetch('/dashboards/list')
    },
    staleTime: Infinity,
  })

  const TABS = useMemo(() => {
    return [...BASE_TABS, ...customTabs]
  }, [customTabs])

  const handleTabChange = (value) => {
    setSearchParams({ tab: value })
  }

  useEffect(() => {
    if (!tab) {
      setSearchParams({ tab: 'calls' })
    }
  }, [tab])

  return (
    <div className={cn('h-full grow bg-white')}>
      <TopBarContent>
        <TopBar.Title>Analytics</TopBar.Title>
        <TopBar.Tabs selectedKey={tab} onSelectionChange={handleTabChange}>
          <TopBar.Tabs.List>
            {TABS?.map(tabItem => (
              <TopBar.Tabs.Tab key={tabItem.value} id={tabItem.value}>
                {tabItem.label}
              </TopBar.Tabs.Tab>
            ))}
          </TopBar.Tabs.List>
        </TopBar.Tabs>
        <TopBar.Actions />
      </TopBarContent>

      {tab === 'calls' && (
        <CallAnalytics />
      )}
      {tab === 'pathways' && (
        <PathwayHeatmap />
      )}
      {tab === 'presets' && (
        <AnalysisPresetConfigurator />
      )}
      {tab === 'citations' && (
        <CitationSchemas />
      )}
      {tab === 'reports' && (
        <ReportPage />
      )}
      {tab?.startsWith('dashboard-') && (
        <RetoolDashboard appID={tab} />
      )}
    </div>
  )
}
